import script from "./ResourceUnitCostsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceUnitCostsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceUnitCostsPage.vue?vue&type=style&index=0&id=e15e420e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e15e420e"]])

export default __exports__